import httpClient from './httpClient';
import { AxiosResponse } from 'axios';

export interface OAuthApproveRequest {
  auth_request_id: string;
  organization_id: number;
}

export interface OAuthApproveResponse {
  redirect_uri: string;
}

export async function approveOAuthRequest(data: OAuthApproveRequest): Promise<AxiosResponse<OAuthApproveResponse>> {
  return httpClient({
    method: 'POST',
    url: '/oauth/approve',
    data,
  });
}
